import { bufferToHex } from '../../../shared/functions/buffer-to-hex.function';
import { canonicalizeMeteringObservedState } from './canonicalize-metering-observed-state.function';
import { MeteringObservedState } from '../types/metering-observed-state.type';

/**
 * SHA-256 hex of the canonical observed state.
 * Uses the Web Crypto API (available in Node, Workers, and browsers) so this
 * shared helper does not import Node's `crypto` module — Angular apps import
 * ultramarine-shared and cannot resolve that builtin.
 */
export async function hashMeteringObservedState(
  state: MeteringObservedState,
): Promise<string> {
  const canonical = canonicalizeMeteringObservedState(state);
  const encoded = new TextEncoder().encode(canonical);
  const digest = await crypto.subtle.digest('SHA-256', encoded);
  return bufferToHex(digest);
}
